import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Button } from 'ui';
import { Redirect } from 'react-router-dom';

import TranscriptBody from './TranscriptBody';
import PageLoadingComponent from './PageLoadingComponent';
import exportNameMapper from 'mappers/exports/ExportNameMapper';
import { useTranscript } from 'hooks/transcripts/queries';
import { useCodes } from 'hooks/codes/queries';
import useCoders from 'hooks/useCoders';
import { useProjectUsers } from 'hooks/users/queries';
import { useCurrentUser } from 'hooks/users/queries';
import { useIsSubscriptionActive } from 'hooks/subscriptions/useIsSubscriptionActive';
import trackingUtil from 'utils/TrackingUtil';


const TranscriptPrintContainer = ({ transcriptID, projectID, project }) => {
  // Use React Query hook for transcript data
  const { data: transcriptData } = useTranscript(transcriptID);
  const {data: codes, isLoading: isLoadingCodes} = useCodes(projectID)
  const { data: currentUser } = useCurrentUser();
  const { data: projectUsers } = useProjectUsers(projectID);
  const coders = useCoders(`/transcripts/${transcriptID}/print`, projectID);
  const isSubscriptionActive = useIsSubscriptionActive();

  const componentRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: exportNameMapper(transcriptData?.name || 'Untitled', null, 'Untitled'),
  });

  const print = () => {
    handlePrint();
    trackingUtil.logEvent('export-transcript-pdf')
  };

  if (
    (project && project.role === 'view_only') ||
    (!isSubscriptionActive && projectID && !!project)
  ) {
    return <Redirect to={`/projects/${projectID}/codes`} />;
  }

  // Ensure we have all required data before rendering
  if (!transcriptData || !codes || !coders || isLoadingCodes) {
    return (
      <div style={{ height: '100vh' }}>
        <PageLoadingComponent />
      </div>
    );
  }

  const transcriptName = transcriptData?.name || 'Untitled';

  return (
    <div style={{ height: '100%' }}>
      <div style={{ marginRight: '20px', marginTop: '20px', float: 'right' }}>
        <Button variant="blue" onClick={print}>Export PDF</Button>
      </div>

      <div style={{ clear: 'both' }}></div>

      <TranscriptBody
        transcriptID={transcriptID}
        transcriptData={transcriptData}
        coders={coders}
        isPrint={true}
        hasEditPermission={false}
        bodyRef={componentRef}
        title={transcriptName}
        setParagraphRef={() => {}}
        selectedExcerptId={null}
        select={null}
        page={null}
      />
    </div>
  );
};

export default TranscriptPrintContainer;
